import React, {useState} from 'react';
import styled from 'styled-components'
import ReactDOM from 'react-dom';

function SingleNumberResult({name, value}) {

    return (
        <Wrapper>
           <Input type='text' name={name} defaultValue={value} />
        </Wrapper>
    );
}

export default SingleNumberResult;


const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
`



const Input = styled.input`
  padding: 4px;
  width: 80px;
  font-size: 16px;
  margin: 4px;
`;


if (document.getElementsByTagName('single-result')) {
    const elements = document.getElementsByTagName('single-result')

    for(let element of elements) {
        ReactDOM.render(
            <SingleNumberResult
            name={element.attributes.name ? element.attributes.name.value : null}
            />, element);
    }

}
